import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EditCaptainsComponent } from './edit-captains.component';
import { EditCaptainsResolve } from './edit-captains.resolve';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'manage/admin/captain/edit/:id',
        component: EditCaptainsComponent,
        resolve: {
          captains: EditCaptainsResolve,
        },
      },
    ]),
  ],
  exports: [RouterModule],
})
export class EditCaptainsRoutingModule {}
